import script from "./MyAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./MyAccountView.vue?vue&type=script&setup=true&lang=js"

import "./MyAccountView.vue?vue&type=style&index=0&id=0de6e316&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de6e316"]])

export default __exports__